export enum Launch_Relax_Stake_Logic {
  "pt-br" = "pt-br",
  "es_ES" = "es_ES",
  "hu" = "hu",
}
